import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onMouseenter", "onClick"]
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["fill", "stroke-width"]

import { ref, computed } from 'vue'

const fillColor = '#f5b301'
const strokeColor = '#f2c94c'

// Rounded-corner star path (slightly softer via rounded joins)
const starPath = `M12 2.5l2.9 5.88 6.5.95-4.7 4.58 1.1 6.46L12 17.9 6.2 20.4l1.1-6.46-4.7-4.58 6.5-.95L12 2.5z`


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    value: {},
    interactive: { type: Boolean, default: false },
    size: { default: 28 }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const hover = ref(0)
const currentValue = computed(() => (props.interactive ? (hover.value || props.value) : props.value))

const size = computed(() => props.size)
const sizePx = computed(() => `${size.value}px`)
const gapPx = computed(() => `${Math.round(size.value * 0.15)}px`)
const strokeWidth = computed(() => Math.max(1.5, size.value * 0.08))
function onEnter(i: number) {
  if (props.interactive) hover.value = i
}
function onLeave() {
  if (props.interactive) hover.value = 0
}
function onClick(i: number) {
  if (props.interactive) emit('update:value', i)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "stars",
    onMouseleave: onLeave,
    style: _normalizeStyle({ gap: gapPx.value })
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
      return _createElementVNode("button", {
        key: i,
        class: _normalizeClass(["star-btn", { interactive: _ctx.interactive }]),
        type: "button",
        onMouseenter: ($event: any) => (onEnter(i)),
        onClick: ($event: any) => (onClick(i)),
        style: _normalizeStyle({ width: sizePx.value, height: sizePx.value }),
        "aria-label": "rate"
      }, [
        (_openBlock(), _createElementBlock("svg", {
          width: size.value,
          height: size.value,
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          _createElementVNode("path", {
            d: starPath,
            fill: (currentValue.value >= i) ? fillColor : 'transparent',
            stroke: strokeColor,
            "stroke-width": strokeWidth.value,
            "stroke-linejoin": "round",
            "stroke-linecap": "round"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      ], 46, _hoisted_1)
    }), 64))
  ], 36))
}
}

})